import { render, staticRenderFns } from "./BindIdentity.vue?vue&type=template&id=5d723554&scoped=true"
import script from "./BindIdentity.vue?vue&type=script&lang=js"
export * from "./BindIdentity.vue?vue&type=script&lang=js"
import style0 from "./BindIdentity.vue?vue&type=style&index=0&id=5d723554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d723554",
  null
  
)

export default component.exports